import { ReactElement, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from 'context'

interface PublicRouteProps {
  children: ReactElement
}

type LoginNavigateProps = { from: { pathname: string } }

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { authState: { state: { user } } } = useAuth()
  const location = useLocation()
  const history = useNavigate()

  useEffect(() => {
    if (user?.consumerActive) {
      let from = null

      if (location.state) ({ from } = location.state as LoginNavigateProps)
      from = from?.pathname

      history(from ?? '/my-vehicles')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location])

  return user?.consumerActive ? <></> : children
}

export default PublicRoute
